import React from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import FaveButton from '../../../../../../FaveButton';
import OverlayControl from '../../../../../Helper/OverlayControl';
import FavingIcon from '../../../../../../FaveButton/FavingIcon';
import VisuallyHidden from '@wix/da-a11y/pkg/components/VisuallyHidden';
import { useOverlayContext } from '../../../../../hooks/useOverlayContext';
import { useDeviationAttributes } from '../../../../../hooks/useDeviationAttributes';
import overlayIconStyles from '../../../../../Helper/OverlayIcons.scss';
var FaveControl = function (_a) {
    var deviation = _a.deviation, className = _a.className, faveCount = _a.faveCount, iconClassName = _a.iconClassName, statClassName = _a.statClassName, isPermanentIcon = _a.isPermanentIcon, size = _a.size, showFlipped = _a.showFlipped, _b = _a.notificationQueue, notificationQueue = _b === void 0 ? 'default' : _b;
    var t = useTranslation().t;
    var showStats = useOverlayContext(deviation).showStats;
    var isFavouritable = useDeviationAttributes(deviation, false).isFavouritable;
    if (!isFavouritable) {
        return null;
    }
    return (React.createElement(FaveButton, { deviation: deviation, className: classnames(overlayIconStyles['icon-button'], className), "aria-label": t('deviationview.overlay.a11y.favourite'), notificationQueue: notificationQueue }, function (_a) {
        var isFavourite = _a.isFavourite;
        return (React.createElement(OverlayControl, { showStats: showStats, stat: faveCount, statClassName: statClassName, showFlipped: showFlipped, extraStatContent: React.createElement(VisuallyHidden, null, t('deviationview.overlay.a11y.favouriteStat')) },
            React.createElement(FavingIcon, { deviationId: deviation.deviationId, isFavourited: isFavourite, size: size, withPadding: false, disableDefaultColors: true, className: classnames(overlayIconStyles['icon'], isFavourite && overlayIconStyles['active'], isPermanentIcon && overlayIconStyles['permanent'], iconClassName) })));
    }));
};
FaveControl.displayName = 'FaveControl';
export default FaveControl;
//# sourceMappingURL=FaveControl.js.map